import * as THREE from 'three'
import Scene from './Scene'
import Road from '@/objects/Road'
import Model from '@/objects/Model'
import Leaves from '@/objects/Leaves'
import config from '@/config/start'
import { times } from '@/utils'
import { loadTexture } from '@/utils/loader'

const clock = new THREE.Clock()

export default class StartScene extends Scene {
  name = 'StartScene'

  constructor (stage) {
    super()

    this.stage = stage

    this.createRoad()
    this.createTrees()
    this.createLeaves()
  }

  createRoad () {
    const { points, width, color, pattern, rotation } = config.road
    const texture = loadTexture(pattern)
    this.road = new Road(points, width, color)
    this.road.setTexture(texture, true)
    this.road.rotateX(rotation)
  }

  createTrees () {
    this.trees = []

    times(config.trees.length, i => {
      const { path, timeScale, rotation, position } = config.trees[i]

      const tree = new Model(path, () => {
        tree.setTimeScale(timeScale)
        tree.rotateY(rotation)
        tree.position.copy(position)
      })

      this.trees.push(tree)
    })
  }

  createLeaves () {
    const { position, ...settings } = config.leaves
    this.leaves = new Leaves(settings)
    this.leaves.position.copy(position)
  }

  start () {
    const { background, fog } = config.scene
    const { x, y, z } = config.camera.position
    const { from, to } = config.camera.focus

    this.stage.setCameraPosition(x, y, z)
    this.stage.setFocus(from.x, from.y, from.z)

    this.stage.changeFocus(to.x, to.y, to.z, 5000)
    this.stage.changeBackground(background)
    this.stage.changeFogColor(fog.color)
    this.stage.changeFogDistance(fog.near, fog.far)

    this.stage.add(this.road)
    this.stage.add(this.leaves)
    this.trees.forEach(child => {
      this.stage.add(child)
    })
  }

  stop () {
    this.stage.remove(this.road)
    this.stage.remove(this.leaves)
    this.trees.forEach(child => {
      this.stage.remove(child)
    })
  }

  update () {
    const delta = clock.getDelta()
    this.leaves.update(delta)
    this.trees.forEach(tree => {
      tree.update(delta)
    })
  }
}
